/**
 *
 * carbon-angular v0.0.0 | carbon-components-angular-forms.js
 *
 * Copyright 2014, 2023 IBM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0

 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'carbon-components-angular/checkbox';
import * as ɵngcc0 from '@angular/core';
export { CheckboxModule, Checkbox, CheckboxChange, CheckboxState } from 'carbon-components-angular/checkbox';
import { ToggleModule } from 'carbon-components-angular/toggle';
export { ToggleModule, Toggle, ToggleChange, ToggleState } from 'carbon-components-angular/toggle';
import { RadioModule } from 'carbon-components-angular/radio';
export { RadioModule, Radio, RadioChange, RadioGroup } from 'carbon-components-angular/radio';
import { InputModule } from 'carbon-components-angular/input';
export { InputModule, Label, TextArea, TextInput, TextInputLabelComponent, TextareaLabelComponent } from 'carbon-components-angular/input';
import { ButtonModule } from 'carbon-components-angular/button';
export { ButtonModule, Button, ButtonSet } from 'carbon-components-angular/button';

// modules
class NFormsModule {
}
NFormsModule.ɵfac = function NFormsModule_Factory(t) { return new (t || NFormsModule)(); };
NFormsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NFormsModule });
NFormsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        CheckboxModule,
        ToggleModule,
        RadioModule,
        InputModule,
        ButtonModule, CheckboxModule,
        ToggleModule,
        RadioModule,
        InputModule,
        ButtonModule,
        InputModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NFormsModule, [{
        type: NgModule,
        args: [{
                exports: [
                    CheckboxModule,
                    ToggleModule,
                    RadioModule,
                    InputModule,
                    ButtonModule,
                    InputModule
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    CheckboxModule,
                    ToggleModule,
                    RadioModule,
                    InputModule,
                    ButtonModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NFormsModule, { imports: function () { return [CommonModule,
        FormsModule,
        CheckboxModule,
        ToggleModule,
        RadioModule,
        InputModule,
        ButtonModule]; }, exports: function () { return [CheckboxModule,
        ToggleModule,
        RadioModule,
        InputModule,
        ButtonModule,
        InputModule]; } }); })();

// export the forms module

/**
 * Generated bundle index. Do not edit.
 */

export { NFormsModule };

